import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

// Preserves the negative value if there is one in the front.
export const addCommas = (wholeNumStr) => {
   let formattedWholeNum;

   if (wholeNumStr.length < 4) {
      formattedWholeNum = wholeNumStr;
   } else {
      formattedWholeNum = `${ wholeNumStr.slice(wholeNumStr.length - 3) }`;
      for (let end = wholeNumStr.length - 3; end > 0; end -= 3) {
         const start = Math.max(end - 3, 0);
         const valToAppend = wholeNumStr.slice(start, end);

         formattedWholeNum = `${ valToAppend },${ formattedWholeNum }`;
      }
   }
   return formattedWholeNum;
};

const formatDecimal = (decimalStr) => {
   let decimal;
   if (!decimalStr) {
      decimal = '00';
   } else if (decimalStr.length > 2) {
      decimal = decimalStr.slice(0, 2);
   } else {
      decimal = decimalStr;
      while (decimal.length < 2) {
         decimal = `${ decimal }0`;
      }
   }
   return decimal;
};

/*
   Handles case where value is
      NaN
      without decimal
      1 decimal place
      high precision (> 2 decimal place)

   Returns a string
 */
export const parseValue = (value, toInteger) => {
   const numberValue = Number(value);
   let strVal;
   if (Number.isNaN(numberValue)) {
      strVal = '0.00';
   } else if (toInteger) {
      const wholeNum = Math.round(numberValue).toString();
      strVal = `$${ addCommas(wholeNum) }`;
   } else {
      const [numStr, decimal] = numberValue.toFixed(2)
         .toString()
         .split('.');

      let hasNegativePrefix = false;
      let wholeNum = numStr;
      if (numStr && numStr.length > 0 && numStr[0] === '-') {
         hasNegativePrefix = true;
         wholeNum = numStr.slice(1);
      }

      strVal = `$${ addCommas(wholeNum) }.${ formatDecimal(decimal) }`;

      if (hasNegativePrefix && strVal !== '$0.00') {
         strVal = `-${ strVal }`;
      }
   }

   return strVal;
};

const CurrencyFormatter = ({ value: propsValue, toInteger }) => {
   const [value, setValue] = useState(parseValue(propsValue, toInteger));

   useEffect(() => {
      setValue(parseValue(propsValue, toInteger));
   }, [propsValue]);

   return (
      <>
         { value }
      </>
   );
};

CurrencyFormatter.propTypes = {
   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
   toInteger: PropTypes.bool, // denotes to round the value to whole number and default rounds up
};

CurrencyFormatter.defaultProps = {
   toInteger: false,
};

export default CurrencyFormatter;
